import {
  Dimensions,
  Platform,
  View,
} from 'react-native';

//import * as rcl from './_csRcl';

import * as ht from './_ht';
import * as cr from './_cr';

import { useKbdMsrz } from './_csKbd';

import { useGblz } from './_csGbl';
import { useSclz } from './_csScl';

import * as icv from 'src/icv';

/*
const _dsnz = rcl.grtAtom('dsnz', {
  nDvcW: Dimensions.get('window').width ?? 350,
  nDvcH: Dimensions.get('window').height ?? 350,
})
*/

const _gDsnz = useGblz('dmn', {
  nDvcW: Dimensions.get('window').width ?? 350,
  nDvcH: Dimensions.get('window').height ?? 350,
});

export const useDsnz = (
) => {

//  const _gCz = useGblz('ctt');

//  const _dz = rcl.grtStt(_dsnz);
  const _sSclz = useSclz();

  const _w = (
    pTgt: 'dvc' | 'bdy' | 'mdl' | 'dwr', 
    pnCmn?: ht.n
  ) => {
    const _nCmn = pnCmn ?? 0;

//    const _nDvcW = _dz.crt.nDvcW;
    const _nDvcW = _gDsnz.crt.nDvcW;
    if ( pTgt == 'dvc' ) {
      return (_nCmn > 0) ? (( _nDvcW - _sSclz.s(_nCmn + 1) ) / _nCmn) : _nDvcW;
    }

    const _nBdyW = _nDvcW;
    if ( pTgt == 'bdy' ) {
      return (_nCmn > 0) ? (( _nBdyW - _sSclz.s(_nCmn + 1) ) / _nCmn) : _nBdyW;
    }

    const _nMdlW = _sSclz.s(icv.dsnz?.nMdlW ?? 0);
    if ( pTgt == 'mdl' ) {
      return (_nCmn > 0) ? (( _nMdlW - _sSclz.s(_nCmn + 1) ) / _nCmn) : _nMdlW;
    }

    const _nDwrW = _sSclz.s(icv.dsnz?.nDwrW ?? 0);
    if ( pTgt == 'dwr' ) {
      return (_nCmn > 0) ? (( _nDwrW - _sSclz.s(_nCmn + 1) ) / _nCmn) : _nDwrW;
    }

    const _nSdrW = _sSclz.s(icv.dsnz?.nSdrW ?? 0);
    if ( pTgt == 'sdr' ) {
      return (_nCmn > 0) ? (( _nSdrW - _sSclz.s(_nCmn + 1) ) / _nCmn) : _nSdrW;
    }

    return 0;
  };

  const _h = (
    pTgt: 'dvc' | 'bdy' | 'hdr' | 'ftr' | 'mdl' | 'dwr',
    pnCmn?: ht.n
  ): ht.n => {
    const _nCmn = pnCmn ?? 0;

//    const _nDvcH = _dz.crt.nDvcH;
    const _nDvcH = _gDsnz.crt.nDvcH;
    if ( pTgt == 'dvc' ) {
//      return _nDvcH;
      return (_nCmn > 0) ? (( _nDvcH - _sSclz.s(_nCmn + 1) ) / _nCmn) : _nDvcH;
    }

    if ( pTgt == 'bdy' ||  pTgt == 'dwr' ) {
      return _nDvcH - ( _h('hdr') + _h('ftr') );
    }

    const _nHdrH = _sSclz.s(icv.dsnz?.nHdrH ?? 0) + (Platform.OS == 'ios' ? _sSclz.s(3) : 0);
    if ( pTgt == 'hdr' ) {
      return (_nCmn > 0) ? (( _nHdrH - _sSclz.s(_nCmn + 1) ) / _nCmn) : _nHdrH;
    }

    const _nFtrH = _sSclz.s(icv.dsnz?.nFtrH ?? 0);
    if ( pTgt == 'ftr' ) {
      return _nFtrH;
    }

    const _nMdlH = _sSclz.s(icv.dsnz?.nMdlH ?? 0);
    if ( pTgt == 'mdl' ) {
      return (_nCmn > 0) ? (( _nMdlH - _sSclz.s(_nCmn + 1) ) / _nCmn) : _nMdlH;
    }
    return 0;
  };

  return {
//    ..._dz,
    ... _gDsnz,
    w: _w,
    h: _h,
  };
}; 

const _DsnRoot = (pd: {
  children: React.FC
}) => {
//  const _sDsnz = useDsnz();
  const _gz = useGblz('dmn');
  const _sKbdMsrz = useKbdMsrz();
  return (
    cr.c(View, {
      key: 'Dsn.root',
      style: {
        width: '100%',
        height: '100%',
      },
      onLayout: ( (_dz: ht.dz) => {
        const nDvcH = _dz.nativeEvent.layout.height;
        const nDvcW = _dz.nativeEvent.layout.width;
        if ( nDvcH > 0 && nDvcW > 0 ) {
          if ( _sKbdMsrz.crt.bShow == false ) {
/*
            const _dz2 = {
              nDvcH,
              nDvcW,
            };
            _sDsnz.set(_dz2);
*/
            _gz.set({
              nDvcH,
              nDvcW,
            });
          }
        }
      }),
    },
      pd.children
    )
  )
}
export default _DsnRoot;
